@if (isDeleting()) {
  <div class="xi-loader-container__inline-overlay xi-loader-container__inline-overlay--blur">
    <xi-animation [height]="75" [width]="75" [loop]="true" animation="cx_loader"></xi-animation>
  </div>
}

<ng-container *transloco="let t; prefix: 'widgets.ai-insights.insight-card'">
  @if (insightCardModel) {
    <div>
      @if (insightFeed) {
        <span class="insight-card__checkbox">
          <mat-checkbox
            [checked]="selectedForDownload"
            (change)="onSelectionChange($event.checked)"
          ></mat-checkbox>
        </span>
      }
      {{ insightCardModel.createdAt | date: 'MMM dd, yyyy HH:mm' }}
    </div>

    <div class="insight-card__header-buttons">
      @if (canUpdateInsights && !insightFeed) {
        <xi-icon-button
          [icon]="insightCardModel.published ? 'document_export_filled' : 'document_export'"
          [color]="insightCardModel.published ? 'disabled' : 'CX'"
          (onClick)="onPublishOrViewClicked()"
          [tooltip]="{
            text: insightCardModel.published ? t('view-published-insight') : t('publish-insight'),
            direction: 5,
          }"
          [disabled]="!insightCardModel.isCompleted"
        >
        </xi-icon-button>
      }
      <xi-icon-button
        icon="copy"
        color="CX"
        (onClick)="copyInsight()"
        [tooltip]="{ text: t('copy-insight'), direction: 5 }"
      >
      </xi-icon-button>
      @if (!insightFeed) {
        <xi-icon-button
          icon="trash"
          color="CX"
          [disabled]="deleteDisabled"
          [tooltip]="deleteTooltip"
          (onClick)="deleteInsight()"
        ></xi-icon-button>
      }
    </div>
    <ng-container *ngTemplateOutlet="insightCardBody; context: { isModal: false }"> </ng-container>

    <div class="insight-card__expand">
      @if (!insightCardModel.error && !insightCardModel.isGenerating) {
        @if (!insightFeed) {
          <span
            (click)="insightCardModel.isExpanded = !insightCardModel.isExpanded"
            class="insight-card__expand-link"
          >
            {{ insightCardModel.isExpanded ? t('read-less') : t('read-more') }}
          </span>
        } @else {
          <span (click)="openInsightFeed()" class="insight-card__expand-link">
            {{ t('read-more') }}
          </span>
        }
      }
    </div>

    <div class="insight-card__actions">
      <!--@if(!isReadOnly) {
      <xi-icon-button
          icon="refresh"
          color="CX"
          [disabled]="insightCardModel.isGenerating"
          (onClick)="regenerateInsightClicked()"
        >
        </xi-icon-button>
      }-->
    </div>
  }

  @if (showPublishModal()) {
    <app-lex-xi-modal [isVisible]="showPublishModal()" (close)="onPublishInsightModalClosed(null)">
      <ng-template appXIModalContent>
        <app-publish-insight-dialog
          [insight]="insight"
          [imageExists]="facade.imageExists()"
          [isImageLoading]="facade.isImageLoading()"
          [insightImage]="facade.insightImage()"
          (modalClosed)="onPublishInsightModalClosed($event)"
        ></app-publish-insight-dialog>
      </ng-template>
    </app-lex-xi-modal>
  }

  @if (showInsightFeedViewModal()) {
    <app-insight-card-modal
      [isVisible]="showInsightFeedViewModal()"
      [canUpdateInsights]="canUpdateInsights"
      [insight]="insight"
      [insightCardModel]="insightCardModel"
      [publishedAt]="publishedAt"
      [publisherDisplayName]="facade.publisherDisplayName()"
      [isImageLoading]="facade.isImageLoading()"
      [imageExists]="facade.imageExists()"
      [insightImage]="facade.insightImage()"
      [bodyTemplate]="insightCardBody"
      (closed)="onInsightFeedViewModalClosed()"
      (editClicked)="onEditInsightClicked(insightCardModel)"
    ></app-insight-card-modal>
  }
</ng-container>

<ng-template #insightCardBody let-isModal="isModal">
  <h5 class="insight-card__title">{{ insightCardModel.shortPurpose }}</h5>

  <div class="insight-card__summary">{{ insightCardModel.summary }}</div>

  <div class="insight-card__insight">
    <ng-container *transloco="let t; prefix: 'widgets.ai-insights.insight-card'">
      @if (insightCardModel.error) {
        <div class="insight-card__error-insight">
          <xi-icon
            icon="warning"
            color="error"
            [tooltipProps]="{ text: insightCardModel.error }"
          ></xi-icon>
          {{ t('error-generating') }}
        </div>
      } @else if (insightCardModel.isGenerating) {
        <div class="insight-card__generating-insight">
          {{ t('generating') }}

          <xi-animation
            [loop]="true"
            animation="cx_loader"
            [width]="25"
            [height]="25"
          ></xi-animation>
        </div>
      } @else {
        <div
          markdown
          [data]="insightCardModel.aiInsight"
          [class.insight-card__insight-content]="!isModal"
          [class.insight-card__insight-content--expanded]="insightCardModel.isExpanded && !isModal"
        ></div>
      }
    </ng-container>
  </div>
</ng-template>
